/**
 * window[ids] library is loaded in HFrame.htm
 */
if (window['idslib']) {
    const idslib = window['idslib'];
    idslib.frameInitialize();
}